export const adminPageSx = {
  flex: "1 1 auto",
  width: "100%",
  maxWidth: "100%",
  minHeight: "100%",
  minWidth: 0,
  overflowX: "hidden",
  boxSizing: "border-box",
  mx: "auto"
};

export const pageTitleSx = {
  color: "warning.main",
  mb: 3
};

export const filterStackSx = {
  display: "grid",
  width: "100%",
  maxWidth: "100%",
  gridTemplateColumns: {
    xs: "1fr",
    sm: "repeat(2, minmax(0, 1fr))",
    lg: "repeat(3, minmax(0, 1fr))"
  },
  gap: 2
};

export const contentCardSx = {
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  overflow: "hidden",
  boxSizing: "border-box"
};

export const metricGridSx = {
  display: "grid",
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  gridTemplateColumns: {
    xs: "1fr",
    sm: "repeat(2, minmax(0, 1fr))",
    lg: "repeat(4, minmax(0, 1fr))"
  },
  gap: 2
};

export const metricCardSx = {
  ...contentCardSx,
  borderRadius: 2,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  p: { xs: 2.5, sm: 3 },
  minHeight: { xs: 124, sm: 140 }
};

export const textWrapSx = {
  minWidth: 0,
  maxWidth: "100%",
  overflowWrap: "anywhere",
  wordBreak: "break-word"
};

export const mobileActionGroupSx = {
  display: "flex",
  flexWrap: "wrap",
  gap: 1,
  width: "100%",
  "& .MuiButton-root": {
    width: { xs: "100%", sm: "auto" },
    minWidth: 0
  }
};

export const dialogActionsResponsiveSx = {
  flexDirection: { xs: "column-reverse", sm: "row" },
  alignItems: "stretch",
  gap: 1,
  px: 3,
  py: 2,
  "& > .MuiButton-root": {
    width: { xs: "100%", sm: "auto" },
    ml: { xs: "0 !important", sm: "8px !important" }
  }
};

export const paginationBarSx = {
  display: "flex",
  width: "100%",
  maxWidth: "100%",
  justifyContent: "center",
  alignItems: "center",
  flexWrap: "wrap",
  gap: 1.5,
  mt: 2.5,
  textAlign: "center"
};
